// extracted by mini-css-extract-plugin
export default {"snackbar":"FailedFetchSnackbar_snackbar__O+DTN","buttonDecoration":"FailedFetchSnackbar_buttonDecoration__lWLiY"};